module.exports = __webpack_public_path__ + "img/team-img1.3f4b763c.jpg";